export default __webpack_public_path__ + "static/Corporate-f56ad5dfaacc0c6761c07c2f016290ab.png";